import { render, staticRenderFns } from "./DxSelectSupervisor.vue?vue&type=template&id=b5c38b88&"
import script from "./DxSelectSupervisor.vue?vue&type=script&lang=js&"
export * from "./DxSelectSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./DxSelectSupervisor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports